import { Axios } from './axios';

const getUserCompanies = async () => {
  const { data } = await Axios.get('/mobile/companies');
  return data?.data;
};

const switchCompany = async (payload) => {
  const { data } = await Axios.get(
    `/mobile/companies/switch-company/${payload}`,
  );
  return data;
};

const generateCompanyOtp = async (payload) => {
  const { data } = await Axios.post('/mobile/companies/generate-otp', payload);
  return data;
};

const confirmCompanyOtp = async (payload) => {
  const { data } = await Axios.post('/mobile/companies/confirm-otp', payload);
  return data;
};

const addCompany = async (payload) => {
  const { data } = await Axios.post('/mobile/companies', payload);
  return data;
};


const getAllNotifications = async (payload) => {
  const { data } = await Axios.get(
    `/mobile/notifications?limit=${payload.limit}&page=${payload.page}`
  )
  return data?.data
}

const openNotification = async (payload) => {
  const { data } = await Axios.put(`/mobile/notifications/mark/${payload.id}`)
  return data
}

const getBirthdayNotifications = async () => {
  const { data } = await Axios.get(`/mobile/birthdays/today`)
  return data?.data
}

const sendBirthdayWish = async (payload) => {
  const { data } = await Axios.post('/mobile/birthdays/send-wishes', payload)

  return data
}
const notificationCount = async () => {
  const { data } = await Axios.get(`/mobile/notifications/unread-count`)
  return data?.data
}

export const companies = {
  getUserCompanies,
  switchCompany,
  generateCompanyOtp,
  confirmCompanyOtp,
  addCompany,
  getAllNotifications,
  openNotification,
  getBirthdayNotifications,
  sendBirthdayWish,
  notificationCount,
}
